import * as Yup from 'yup';
export const initialDocumentValues = {
    name: '',
    workflowStatusId: '',
    fileType: undefined,
    documentTypeId: '',
};
export const documentSchema = Yup.object().shape({
    name: Yup.string(),
    workflowStatusId: Yup.string(),
});
//# sourceMappingURL=document.js.map